import type {
    Page,
    ShippingRequirementCustomerForm,
    ShippingRequirementCustomerQueryParams,
    ShippingRequirementCustomerVo,
    ShippingRequirementPlat
} from "@zhihaoscm/entity";

import { BaseService } from "@/api/baseService";
import httpRequest from "@/api/index";

export class ShipRequireService extends BaseService<
    ShippingRequirementPlat,
    ShippingRequirementCustomerVo,
    ShippingRequirementCustomerQueryParams,
    ShippingRequirementCustomerForm
> {
    /**
     * 按ID获取详情
     * @param id
     */
    async getInfo(id: number): Promise<ShippingRequirementCustomerVo> {
        const { data } = await this.service.get(`${this.path}/find/vo/${id}`);
        return data;
    }

    /**
     * 新增
     * @param params
     */
    async add(params: ShippingRequirementCustomerForm): Promise<ShippingRequirementPlat> {
        const { data } = await this.service.post(`${this.path}`, params);
        return data;
    }

    /**
     * 导入上次找船数据
     */
    async importLastData(): Promise<ShippingRequirementPlat> {
        const { data } = await this.service.get(`${this.path}/last`);
        return data;
    }

    /**
     * 取消船运需求
     * @param id
     */
    async close(id: number, params:{reasonType:number;reasonContent?:string}) {
        await this.service.get(`${this.path}/cancel/${id}`, {params});
    }

    /**
     * 确认船运需求
     * @param id
     */
    async confirm(id: number) {
        await this.service.put(`${this.path}/confirm/${id}`);
    }

    /**
     * 货主运单查询列表 获取分页列表
     */
    async getOrderPaging(params: ShippingRequirementCustomerQueryParams): Promise<Page<ShippingRequirementCustomerVo>> {
        const { data } = await this.service.get(`${this.path}/custom/orderPaging`, { params });
        return data;
    }

    /**
     * 运单详情 有运单id传运单id
     */
    async getOrderDetail(params: { requireId?: number; orderId?: string }): Promise<ShippingRequirementCustomerVo> {
        const { data } = await this.service.get(`${this.path}/custom/orderDetail`, { params });
        return data;
    }
}
export const shipRequirementService = new ShipRequireService("/shipping/plat/owner", httpRequest);
